<template>
  <rpm-modal persist :open="open" class="flex flex-col gap-y-8" @close="form.content = '', $emit('close')">
    <rpm-input
      v-model="form.content"
      :errors="errors.content"
      label="Justificativa"
      placeholder="Justificativa"
      required
    ></rpm-input>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
        @click="$emit('close')"
        color="gray"
        label="Fechar"
      ></rpm-button>

      <rpm-button
        label="Cancelar"
        color="red"
        @click="cancelService"
      ></rpm-button>
    </section>
  </rpm-modal>
</template>

<script>

import RpmModal from "#components/RpmModal.vue";
import serviceRepository from "#repositories/serviceRepository";

export default {
  name: 'CancelServiceModal',
  components: {
    RpmModal
  },
  props: {
    service: {
      type: Object
    },
    open: {
      type: Boolean
    }
  },
  data() {
    return {
      form: {
        content: ''
      },
      errors: {}
    }
  },
  methods: {
    cancelService() {
      serviceRepository.cancelService(this.service.id, this.form).then((response) => {
        this.$notify('Solicitação cancelada com sucesso', 'success');
        this.service.servicestatusname = 'Cancelado';
        this.service.servicestatuscolor = '#f13939';
        this.service.canceled = true;
        this.form.content = '';
        this.$emit('canceled')
        this.$emit('close');
      }).catch((response) => {
        this.$notify('Justificativa inválida', 'error');
        this.errors.content = response.errors.content;
      });
    },
  }
}
</script>